import { LocalitaTab } from "@/modules/localitaTab";

export const actions = {
	LOGIN_SUCCESS: "LOGIN_SUCCESS",
	LOGOUT: "LOGOUT",
	LOGIN_ERROR: "LOGIN_ERROR",
	LOADING: "LOADING",
}

export const switchDay: number = 18;
export const emailRegex: RegExp = /^\S+@\S+\.\S+$/;


export const localitaTabsList: LocalitaTab[] = [
	{
		id: 7300,
		name: "Torino",
		showData: {
			simbolo_meteo: true,
			temperatura: true,
			precipitazioni: true,
			umidita: false,
			zero_termico: false,
			quota_neve: false,
			vento_medio: true,
			raffica: true
		}
	},
	{
		id: 5259,
		name: "Pinerolo",
		showData: {
			simbolo_meteo: true,
			temperatura: true,
			precipitazioni: true,
			umidita: false,
			zero_termico: false,
			quota_neve: false,
			vento_medio: true,
			raffica: true
		}
	},
	{
		id: 7338,
		name: "Torre Pellice",
		showData: {
			simbolo_meteo: true,
			temperatura: true,
			precipitazioni: true,
			umidita: false,
			zero_termico: false,
			quota_neve: false,
			vento_medio: true,
			raffica: true
		}
	},
	{
		id: 5508,
		name: "Pragelato",
		showData: {
			simbolo_meteo: true,
			temperatura: true,
			precipitazioni: true,
			umidita: true,
			zero_termico: true,
			quota_neve: true,
			vento_medio: true,
			raffica: true
		}
	},
	{
		id: 523,
		name: "Bardonecchia",
		showData: {
			simbolo_meteo: true,
			temperatura: true,
			precipitazioni: true,
			umidita: true,
			zero_termico: true,
			quota_neve: true,
			vento_medio: true,
			raffica: true
		}
	},
	{
		id: 6866,
		name: "Sestriere",
		showData: {
			simbolo_meteo: true,
			temperatura: true,
			precipitazioni: true,
			umidita: true,
			zero_termico: true,
			quota_neve: true,
			vento_medio: true,
			raffica: true
		}
	},
]